import * as types from './subject.types'

const initialState = {
	isLoading: false,
	isSuccess: false,
	subject: {},
	options: {
		static: {},
		dynamic: {},
	},
	errors: {},
	permissions: {},
}

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case types.TOGGLE_LOADING:
			return {
				...state,
				isLoading: action.payload,
			}
		case types.TOGGLE_SUCCESS:
			return {
				...state,
				isSuccess: action.payload,
			}
		case types.SET_SUBJECT:
			return {
				...state,
				subject: action.payload,
			}
		case types.SET_OPTIONS:
			return {
				...state,
				options: {
					...state.options,
					[action.payload.name]: action.payload.data,
				},
			}
		case types.SET_PERMISSIONS:
			return {
				...state,
				permissions: action.payload,
			}
		case types.SET_ERRORS:
			return {
				...state,
				errors: action.payload,
			}
		default:
			return state
	}
}
